import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { useStyles } from './ReceivableItem.styled';

const ReceivableItem = ({ title, description, fontSize, fontWeight, extra }) => {
  const classes = useStyles();

  return (
    <Box display="flex" alignItems="center" data-cy="receivable-item">
      <Typography component="span" className={classes.textColor}>
        <Box fontSize={fontSize || 13} component="span" fontWeight="fontWeightBold">
          {title}:
        </Box>
      </Typography>
      <Typography component="span">
        <Box
          ml={1}
          component="span"
          fontSize={fontSize || 13}
          fontWeight={fontWeight || 'fontWeightRegular'}
        >
          {description || '--'}
        </Box>
      </Typography>
      {extra && extra}
    </Box>
  );
};

export default ReceivableItem;
